export const Wrapper =
  'font-Roboto mb-4 flex flex-col text-black sm:flex-row sm:items-center'

export const GoBackWrapper =
  'font-Roboto text-14 sm:border-mediumGray hover:text-mediumGray cursor-pointer underline transition duration-200 ease-in sm:mr-2 sm:border-r sm:pr-2'
